import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Container } from "@chakra-ui/react";

import usePathNavigate from "../lib/hook/usePathNavigate";
import { getExternalSign, getPaymentsInfo } from "./api";
import { ResStatus } from "../lib/api/enum";

import { Helmet } from "react-helmet-async";

const Payments = () => {
    const location = useLocation();
    console.log("location : ", location);
    const searchParams = new URLSearchParams(location.search);

    const { pathNavigate } = usePathNavigate();

    const getPaymentInfoFromToken = async () => {
        let token = searchParams.get("t");
        console.log("t : ", token);

        if (token == null) token = localStorage.getItem("paymentToken");

        console.log("paymentToken2 : ", token);

        if (token != null && token!.length > 0) {
            localStorage.setItem("paymentToken", token);

            try {
                const result_sign = await getExternalSign({
                    external_token: token,
                });

                // return await pathNavigate("/oemrequestpay/sms", {  // test
                //     state: {
                //         order_id: 1111,
                //         order_status: 1,
                //         payment_status: 9,
                //         receipt_code: "CM241031-2831",
                //         account_name: "김민수",
                //         brand_name: "",
                //         item_name: "",
                //         payer_name: "",
                //         payer_phone_num: "",
                //         payment_amount: 1000,
                //         merchant_uid: "1111",
                //         service_contents: "",
                //         process_contents: "",
                //         request_date: 1111111111,
                //     },
                // });

                if (result_sign.status === ResStatus.RES_SUCCESS) {
                    const order_id = result_sign.command.sign_info.order_id;
                    const result_payment = await getPaymentsInfo({
                        order_id: order_id,
                    });
                    console.log("getPaymentsInfo : ", result_payment);

                    if (result_payment.status === ResStatus.RES_SUCCESS) {
                        pathNavigate("/oemrequestpay/sms", {
                            state: result_payment.command,
                        });
                    }
                } else pathNavigate("/oemrequestpay/expiration");
            } catch (err: any) {
                pathNavigate("/oemrequestpay/expiration");
            }
        } else pathNavigate("/oemrequestpay/expiration");
    };

    useEffect(() => {
        getPaymentInfoFromToken();
    }, []);

    return (
        <Container
            maxW={"768px"}
            minW={"320px"}
            w={"100%"}
            height={"100vh"}
            px={0}
            bg={"white"}
        >
            <Helmet>
                <title>결제진행</title>
            </Helmet>
            {<Outlet />}
        </Container>
    );
};

export default Payments;
